export default "__VITE_ASSET__kjcCOzeK__"